'use client';

import React from 'react';

import { Rating } from '@bytel/product-wall';
import {
    Alignable,
    Justifiable,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    TextMarkup,
    Title,
    TitleLevels,
    TitleMarkup,
    View,
} from '@bytel/trilogy-react';

import { NumeriquesReviewInformation } from '@app-types/numeriques';
import { ProductChildFull } from '@app-types/product';
import { ReviewsInfoType } from '@app-types/review';

import { TabsEnum } from '@product-detail/components';

export type ProductHeaderProps = {
    isMobile?: boolean;
    currentProduct: ProductChildFull;
    reviews?: ReviewsInfoType;
    publication?: NumeriquesReviewInformation['publications'][number];
    setActiveTab: (tab: TabsEnum) => void;
};

export function ProductHeader({ currentProduct, reviews, publication, setActiveTab }: ProductHeaderProps) {
    const { parentTitle, color, capacity } = currentProduct;

    const scrollToTabs = (tabs: TabsEnum, id: string) => {
        setActiveTab(tabs);

        // setTimeOut in order to delay the execution of scrollIntoView
        // until after the state update has been applied and the component has re-rendered
        setTimeout(() => {
            document.getElementById(id)?.scrollIntoView({
                behavior: 'smooth',
            });
        }, 0);
    };

    return (
        <View flexable justify={Justifiable.SPACE_BETWEEN} className='gap-medium is-flex-col-touch product-title'>
            <div className='has-text-centered-touch'>
                <Title markup={TitleMarkup.H1} level={TitleLevels.FOUR} marginless>
                    {parentTitle}
                </Title>
                <Text markup={TextMarkup.SPAN} level={TextLevels.TWO} marginless>
                    {`${color ?? ''} ${capacity ?? ''}`}
                </Text>
            </div>
            {(reviews || publication) && (
                <div>
                    {reviews && (
                        <>
                            <View
                                flexable
                                align={Alignable.ALIGNED_CENTER}
                                className='gap-medium w-auto desktop-justify-end cursor-pointer is-justified-center-touch'
                                onClick={() => scrollToTabs(TabsEnum.REVIEWS, 'reviews-section')}
                            >
                                <Rating rating={reviews.note * 2} />
                                <button role='button' className='button-clear link'>
                                    {reviews.reviewCount}&nbsp;avis
                                </button>
                            </View>
                            <Spacer size={SpacerSize.ONE} />
                        </>
                    )}
                    {publication && (
                        <View
                            flexable
                            align={Alignable.ALIGNED_CENTER}
                            className='gap-medium w-auto desktop-justify-end cursor-pointer is-justified-center-touch'
                            onClick={() => scrollToTabs(TabsEnum.PARTNER, 'partner-section')}
                        >
                            <img
                                src='https://cdn.lesnumeriques.com/assets/2024/04/30/1714489863461/newebfrontstyleguide/build/img/svg/logo-horizontal.svg'
                                alt='Les Numériques'
                                width='80px'
                                loading='lazy'
                            />
                            <button role='button' className='button-clear link'>
                                Voir l&apos;avis complet
                            </button>
                        </View>
                    )}
                </div>
            )}
        </View>
    );
}
